"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var splitCommonFromProps = function splitCommonFromProps(object, keys) {
  return Object.keys(object).reduce(function (acc, item) {
    if (keys.includes(item)) {
      acc[0][item] = object[item];
    } else {
      acc[1][item] = object[item];
    }
    return acc;
  }, [{}, {}]);
};
var _default = exports.default = splitCommonFromProps;